<script setup lang="ts">
import FilterField from '@/components/atoms/element-filters/FilterField.vue'
import EdgeCategoryFilter from '@/components/atoms/swade/EdgeCategoryFilter.vue'

const types = defineModel<string[]>('types', { default: () => [] })
defineProps<{ label?: string; placeholder?: string }>()

const onChange = (event: any): void => {
  types.value = (event?.value ?? []).map((item: any) => item.alias)
}
</script>

<template>
  <FilterField :label="label">
    <EdgeCategoryFilter :placeholder="placeholder" :selected="types" @category-selected="onChange" />
  </FilterField>
</template>
